import { TrendingUp } from 'lucide-react';
import { PlaceholderText } from '../../ui/Placeholder';

interface MarketEffect {
  name: string;
  value: string;
  expiration: string;
}

interface ActiveMarketEffectsProps {
  effects?: MarketEffect[];
  className?: string;
}

export function ActiveMarketEffects({ effects, className = "" }: ActiveMarketEffectsProps) {
  // Default effects if none provided
  const defaultEffects: MarketEffect[] = [
    { name: "consumer demand", value: "+15%", expiration: "Until Dec 31" }, // TODO: Dynamic market effects
    { name: "tech score", value: "+10%", expiration: "Until Jan 15" }, // TODO: Dynamic market effects
    { name: "production costs", value: "+8%", expiration: "Until Feb 1" } // TODO: Dynamic market effects
  ];

  const displayEffects = effects || defaultEffects;

  return (
    <div className={`bg-theme-bg-content rounded-lg shadow p-4 ${className}`}>
      <h3 className="text-sm font-semibold text-theme-text-primary mb-3 flex items-center">
        <TrendingUp className="w-4 h-4 mr-2" />
        Active Market Effects ({displayEffects.length})
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {displayEffects.map((effect, index) => (
          <div key={index} className="flex items-center justify-between p-2 bg-blue-50 rounded text-xs">
            <span className="font-medium">{effect.name}: <PlaceholderText text={effect.value} /></span>
            <span className="text-theme-text-muted ml-2">{effect.expiration}</span>
          </div>
        ))}
      </div>
    </div>
  );
}